import React, { useState, useEffect } from "react";
import { Input, Button, Icon, Dropdown } from 'semantic-ui-react';
import OrderAgGridTable from "../../components/common/orderadGridTable";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import MoveToVehicleAvailability from "./moveToVehicleAvailability";
import allAxiosCommonTA from "../axiosComponent/allAxiosCommonTA";
import { FEATURES } from "../../utils/constant";

function AvailablilityPlanning(props) {
  const [availablilityListHeader, setAvailablilityListHeader] = useState([]);
  const [availablilityHeader, setAvailablilityHeader] = useState('Branch');
  const [availablilityHeaderType, setAvailablilityHeaderType] = useState(['branch']);
  const [rowData, setRowData] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(['branch']);
  const [searchElement, setSearchElement] = useState('');
  const [searchHistory, setSearchHistory] = useState('');
  const [dataHistory, setDataHistory] = useState(0);


  useEffect(() => {
    setHeaderListCurrent(6)

    //let tempboll = [{ booking_branch: 'delhi', status: 1 }];
    //setRowData(tempboll)
    availablePlanningInit(["branch"], 0)
  }, []);

  let setHeaderListCurrent = (index) => {
    let date = new Date();
    let temp_arr = [];
    for (let i = 0; i <= index; i++) {
      var new_date = moment(date, "DD-MM-YYYY").add('days', i);
      let tempdate = new_date.format('DD MMM');
      temp_arr.push(tempdate)
    }
    setAvailablilityListHeader(temp_arr)
  }

  let setHeaderListPast = (index) => {
    let date = new Date();
    let temp_arr = [];
    for (let i = index; i >= 0; i--) {
      var new_date = moment(date, "DD-MM-YYYY").subtract('days', i);
      let tempdate = new_date.format('DD MMM');
      temp_arr.push(tempdate)
    }
    setAvailablilityListHeader(temp_arr)
  }

  let availablePlanningInit = (filterData, searchHistory) => {
    allAxiosCommonTA({ url: "/vehicle/availability/planning?history=" + searchHistory, method: "post", Items: { filters: filterData } })
      .then((response) => {
        let tempArr = response.data.data.data;
        let tempTotal = response.data.data.total_column_counts;
        let history = response.data.data.history;

        setSearchHistory(history)

        tempTotal.name = "Total Availability";
        setTotalRowCount([tempTotal])

        let matchArray = [];
        let totalFiltersToIterate = filterData.length;
        for (let index = 0; index < options.length; index++) {
          let element = options[index].value.trim().toLocaleLowerCase();
          matchArray.push(element)
        }
        console.log('totalFiltersToIterate')
        console.log(totalFiltersToIterate)
        /* accordian object start */
        const keys = Object.keys(tempArr);

        let dataArray = [];
        keys.forEach((key, index) => {
          if (totalFiltersToIterate > 1) {
            const keyLoop1 = Object.keys(tempArr[key]);
            const objLoop1 = tempArr[key];
            keyLoop1.forEach((key1, index1) => {
              if (totalFiltersToIterate > 2) {
                const keyLoop2 = Object.keys(objLoop1[key1]);
                const objLoop2 = objLoop1[key1];
                keyLoop2.forEach((key2, index2) => {
                  if (totalFiltersToIterate > 3) {
                    const keyLoop3 = Object.keys(objLoop2[key2]);
                    const objLoop3 = objLoop2[key2];
                    keyLoop3.forEach((key3, index3) => {

                      if (totalFiltersToIterate > 4) {
                        const keyLoop4 = Object.keys(objLoop3[key3]);
                        const objLoop4 = objLoop3[key3];
                        keyLoop4.forEach((key4, index4) => {

                          if (totalFiltersToIterate > 5) {
                            const keyLoop5 = Object.keys(objLoop4[key4]);
                            const objLoop5 = objLoop4[key4];
                            keyLoop5.forEach((key5, index5) => {
                              keyLoop5.forEach(element => {
                                dataArray.push(objLoop5[element])
                              });
                            })
                          }
                          else {
                            const valueKeyLoop = Object.keys(objLoop4[key4]);
                            const valueObjectLoop = objLoop4[key4];
                            valueKeyLoop.forEach(element => {
                              dataArray.push(valueObjectLoop[element])
                            });
                          }

                        })
                      }
                      else {
                        const valueKeyLoop = Object.keys(objLoop3[key3]);
                        const valueObjectLoop = objLoop3[key3];
                        valueKeyLoop.forEach(element => {
                          dataArray.push(valueObjectLoop[element])
                        });
                      }


                    })
                  }
                  else {
                    const valueKeyLoop = Object.keys(objLoop2[key2]);
                    const valueObjectLoop = objLoop2[key2];
                    valueKeyLoop.forEach(element => {
                      dataArray.push(valueObjectLoop[element])
                    });
                  }
                })
              } else {
                const valueKeyLoop = Object.keys(objLoop1[key1]);
                const valueObjectLoop = objLoop1[key1];
                valueKeyLoop.forEach(element => {
                  dataArray.push(valueObjectLoop[element])
                });
              }
            })
          }
          else {
            const valueKeyLoop = Object.keys(tempArr[key]);
            const valueObjectLoop = tempArr[key];
            valueKeyLoop.forEach(element => {
              dataArray.push(valueObjectLoop[element])
            });
          }
        })

        /* accordian object ends */
        let objectArray = [];
        for (let index = 0; index < dataArray.length; index++) {
          if (dataArray[index].length > 1) {
            for (let indexj = 0; indexj < dataArray[index].length; indexj++) {
              let dateArray = [];
              for (let indexk = 1; indexk <= 7; indexk++) {
                if (indexk == dataArray[index][indexj]["date_index"]) {
                  dataArray[index][indexj]['Day ' + indexk] = dataArray[index][indexj]["count"];
                } else {
                  dataArray[index][indexj]['Day ' + indexk] = 0;
                }
              }
              objectArray.push(dataArray[index][indexj])
            }
          } else {
            for (let indexk = 1; indexk <= 7; indexk++) {
              if (indexk == dataArray[index][0]["date_index"]) {
                dataArray[index][0]['Day ' + indexk] = dataArray[index][0]["count"];
              } else {
                dataArray[index][0]['Day ' + indexk] = 0;
              }
            }
            objectArray.push(dataArray[index][0])
          }
        }

        var o = {}
        objectArray = objectArray.map((a) => {
          a['Day 1'] = parseInt(a['Day 1'])
          a['Day 2'] = parseInt(a['Day 2'])
          a['Day 3'] = parseInt(a['Day 3'])
          a['Day 4'] = parseInt(a['Day 4'])
          a['Day 5'] = parseInt(a['Day 5'])
          a['Day 6'] = parseInt(a['Day 6'])
          a['Day 7'] = parseInt(a['Day 7'])
          return a;
        });

        let dataArrayAssemble = []

        if (objectArray.length > 0) {
          var key = 'booking_branch_id' //+ '|' + 'vendor_id' + '|' + 'load_type_id' + '|' + 'vehicle_type_id';
          let keyArr = [];

          keyArr.push(objectArray[0]['booking_branch_id'])
          objectArray.forEach(element => {
            console.log(element)
            if (!keyArr.includes(element['booking_branch_id'])) {
              keyArr.push(element['booking_branch_id'])
            }
          });

          keyArr.forEach(element => {

            var result = objectArray.reduce(function (r, e) {
              if (!o[key] && e[key] == element) {
                o = e;
                r.push(o);
              } else if (o[key] == e[key] && e[key] == element) {
                o['Day 1'] += e['Day 1'];
                o['Day 2'] += e['Day 2'];
                o['Day 3'] += e['Day 3'];
                o['Day 4'] += e['Day 4'];
                o['Day 5'] += e['Day 5'];
                o['Day 6'] += e['Day 6'];
                o['Day 7'] += e['Day 7'];
              }
              return r;
            }, []);

            o = {};

            dataArrayAssemble.push(result[0])
          });
        }

        setRowData(dataArrayAssemble)

        // setRowData(objectArray)

        props.setTotalAvailability(response.data.data.total_count)
        props.setPendingAvailability(response.data.data.pending)
        props.setAllottedAvailability(response.data.data.alloted)
        props.setOverallTotalAvailability(response.data.data.overall_total)
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  let columnDefs = [
    {
      headerName: availablilityHeader,
      field: "city_name", // vehicle_type
      sortable: true,
      filter: true,
      pinned: 'left',
      rowGroup: true,
      hide: true,
    },
    {
      field: 'booking_branch_name',
      rowGroup: true,
      hide: true,
    },
    {
      field: 'vendor_name',
      rowGroup: true,
      hide: true,
    },
    {
      field: 'vehicle_type',
      rowGroup: true,
      hide: true,
    },
    {
      field: 'load_type_name',
      rowGroup: true,
      hide: true,
    },
    {
      headerName: availablilityListHeader[0],
      field: "Day 1", // vehicle_type
      cellRenderer: "MoveToVehicleAvailability",
      sortable: true,
      filter: true,
      minWidth: 120,
      width: 120,
      maxWidth: 120,
    },
    {
      headerName: availablilityListHeader[1],
      field: "Day 2", // vehicle_type
      cellRenderer: "MoveToVehicleAvailability",
      headerClass: 'cell-gray',
      cellClass: 'cell-gray',
      sortable: true,
      filter: true,
      minWidth: 120,
      width: 120,
      maxWidth: 120,
    },
    {
      headerName: availablilityListHeader[2],
      field: "Day 3", // vehicle_type
      cellRenderer: "MoveToVehicleAvailability",
      sortable: true,
      filter: true,
      minWidth: 120,
      width: 120,
      maxWidth: 120,
    },
    {
      headerName: availablilityListHeader[3],
      field: "Day 4", // vehicle_type
      cellRenderer: "MoveToVehicleAvailability",
      headerClass: 'cell-gray',
      cellClass: 'cell-gray',
      sortable: true,
      filter: true,
      minWidth: 120,
      width: 120,
      maxWidth: 120,
    },
    {
      headerName: availablilityListHeader[4],
      field: "Day 5", // vehicle_type
      cellRenderer: "MoveToVehicleAvailability",
      sortable: true,
      filter: true,
      minWidth: 120,
      width: 120,
      maxWidth: 120,
    },
    {
      headerName: availablilityListHeader[5],
      field: "Day 6", // vehicle_type
      cellRenderer: "MoveToVehicleAvailability",
      headerClass: 'cell-gray',
      cellClass: 'cell-gray',
      sortable: true,
      filter: true,
      minWidth: 120,
      width: 120,
      maxWidth: 120,
    },
    {
      headerName: availablilityListHeader[6],
      field: "Day 7", // vehicle_type
      cellRenderer: "MoveToVehicleAvailability",
      sortable: true,
      filter: true,
      minWidth: 120,
      width: 120,
      maxWidth: 120,
    },
  ]

  var frameworkcomponent = {
    MoveToVehicleAvailability: MoveToVehicleAvailability,
  }

  /* let handleFilter = () => {
      console.log("filter clicked")
      let toggleElement = document.getElementById('panel-filter-button-availability').classList.toggle("active-filter-button");
      if (toggleElement) {
          console.log("i")
          document.getElementById('panel-filter-button-availability').style.maxHeight = "200px";
      } else {
          console.log("j")
          document.getElementById('panel-filter-button-availability').style.maxHeight = "0px";
      }
      console.log(toggleElement)
  } */
  var options = [{ key: '1', text: 'Vendor', value: 'vendor' }, { key: '1', text: 'City', value: 'city' }, /* { key: '0', text: 'Branch', value: 'branch' }, */ { key: '1', text: 'Load Type', value: 'loadType' }, { key: '1', text: 'Vehicle Type', value: 'vehicleType' }]
  var handleChange = (value, data) => {
    let valueFiltered = data.options.filter((itr, index) => { if (itr.value == data.value) { return itr; } });
    //setAvailablilityHeader(valueFiltered[0].text)
    let arrSend = [...data.value];
    arrSend.unshift('branch')

    //setAvailablilityHeaderType(data.value)
    setAvailablilityHeaderType(arrSend)
    setSearchElement(" ")
    //setSelectedFilter(data.value)
    setSelectedFilter(arrSend)
    //availablePlanningInit(data.value, dataHistory)
    availablePlanningInit(arrSend, dataHistory)
  }
  var handleSearch = (value, data) => {
    let inputValue = data.value;
    setSearchElement(inputValue)
  }

  var handleHistoryChange = (event) => {
    console.log(event.target.checked)
    if (event.target.checked) {
      setHeaderListPast(7)
      setDataHistory(1)
      availablePlanningInit(availablilityHeaderType, 1)
    } else {
      setHeaderListCurrent(6)
      setDataHistory(0)
      availablePlanningInit(availablilityHeaderType, 0)
    }
  }

  return (
    <>
      <div className="planning-header-container">
        <div className="planning-header-context">
          <h3 className="planning-content-header">Vehicle availability</h3>
        </div>

        <div className="planning-header-search display-flex-center-justify-spacebtwn">
          <Input
            size="mini"
            className="mr-1"
            //onKeyUp={props.handleSearch}
            icon={{ name: 'search', circular: true }}
            iconPosition='left'
            placeholder={"Search"}
            onChange={handleSearch}
          />
          <div>
            <Dropdown
              selection
              style={{ width: '100%' }}
              options={options}
              onChange={handleChange}
              placeholder="Branch"
              multiple
            ></Dropdown>
            {/* <Button size="mini" basic className="ml-1 w3-border-light-grey accordion-filter-button" onClick={handleFilter} color="#f1f1f1" icon >
                            <Icon name="filter" />
                        </Button> */}
          </div>
        </div>
      </div>

      <div className='padding-10'>
        <label className="black-text">
          <Input className='padding-r10' type="checkbox" onChange={handleHistoryChange} />
          Backdated Indents
        </label>
      </div>

      {/* <div id="panel-filter-button-availability" className="panel-filter-button">
                Filter
            </div> */}
      <div className="panel-filter-aggrid">
        <OrderAgGridTable
          columnDefs={columnDefs}
          pagination={false}
          titleBarTitle="Indents"
          //baseURL={"orders"}
          passed={props}
          extracomponents={frameworkcomponent}
          rowData={rowData}
          searchHistory={searchHistory}
          pinnedBottomRowData={totalRowCount}
          selectedFilter={selectedFilter}
          searchElement={searchElement}
          dataHistory={dataHistory}
          // suppressRowClickSelection={true}
          //enableCellChangeFlash={true}
          //keyIndex={"u_id"}
          showFilter={false}
          agTotalRowCountComponent={totalRowCount}
          groupDefaultExpanded={ FEATURES.vehicleAvailabilityExpandedViewByDefault ? 1 : 0 }
        />
      </div>
    </>
  )
}

export default AvailablilityPlanning
